import React from 'react';
import classNames from 'classnames';
import Intl from '@fx-ui/intl';
import LoginSwitch from '../login-switch';
import { isInvitationMode } from '../../utils/invite';
import { getBrandInfo } from '~/utils/brand';
import { isMobileUA } from '~/utils';

interface RegisterTitleProps {
    hasLoginSwitch?: boolean;
}

const RegisterTitle: React.FC<RegisterTitleProps> = ({ hasLoginSwitch }) => {
    const renderContent = () => {
        if (isInvitationMode) {
            const corpName = window.jdy_invitation_info?.invitedBy?.name;
            return (
                <>
                    <div className="invite-corp-name" title={corpName}>
                        {corpName}
                    </div>
                    <div className="invite-corp-title">{Intl.get('member.invite.join.title')}</div>
                </>
            );
        }

        return getBrandInfo().registerTitle;
    };

    return (
        <div
            className={classNames('fx-register-title', {
                'is-mobile': isMobileUA()
            })}
        >
            <div
                className={classNames('title', {
                    'hide-login-switch': !hasLoginSwitch
                })}
            >
                {renderContent()}
            </div>
            {hasLoginSwitch && <LoginSwitch />}
        </div>
    );
};

export default RegisterTitle;
